import React, { useContext, useState, useEffect, useRef } from "react";
import Swal from "sweetalert2";
import { FiBell, FiChevronDown } from "react-icons/fi";
import {
  RxDotFilled,
  RxExclamationTriangle,
} from "react-icons/rx";
import { VscAccount } from "react-icons/vsc";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { AppContext } from "../context";
import Breadcrumb from "../helpers/Breadcrumb";
import { getAllNavNotifications, updateNotification } from "../helpers/Api";
import MessageUser from "../components/MessageUser";
//Assets
import logoAAAPver from "../assets/Images/pie_logo.jpg";
import {NotificacionesContext} from "../context/notificaciones";

const NavBar = () => {
  const location = useLocation();
  const { dispatch } = useContext(AppContext);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const nombre_usuario = localStorage.getItem("nombre_usuario");
  //STATES
  const [allNotifications, setAllNotifications] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [notificationDisplay, setNotificationDisplay] = useState(0);
  const {totalNotificaciones} = useContext(NotificacionesContext);

  //ALERTS
  const [alert, setAlert] = useState();
  let menuRef = useRef();
 

  useEffect(() => {
    let clickHandler = (e) => {
      if (!menuRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", clickHandler);

    return () => {
      document.removeEventListener("mousedown", clickHandler);
    };
  }, []);

  const notificationHandler = async (value) => {
    try {
      const fecha_visto = new Date().toJSON().slice(0, 10);
      const response = await updateNotification(
        value.id,
        { fecha_visto: fecha_visto },
        token
      );
      if(role === 'ASC' && value?.tipo === 'CAG') {      
        navigate(`/perfil-agente/${value.param_3}/detalle-operaciones/${value.param_1}/#comentarios`); 
        location.pathname.includes('detalle-operaciones') && window.location.reload();
      } 
        else if(role === 'ASC' && value?.tipo === 'CMA'){
        navigate(`/perfil-agente/${value.param_3}/#generales`); 
        location.pathname.includes('detalle-operaciones') && window.location.reload();
      }
        else if(role === 'ASC' && value?.tipo === 'CAL'){
        navigate(`/perfil-agente/${value.param_3}/#generales`); 
        location.pathname.includes('detalle-operaciones') && window.location.reload();
      }
       else if(role === 'ASC' && value?.tipo === 'CMD'){
        navigate(`/perfil-agente/${value.param_3}/#generales`); 
        location.pathname.includes('detalle-operaciones') && window.location.reload();
      }
        else if (role === 'AGA' && value?.tipo === 'CAA') {
        navigate(`/detalle-operaciones/${value.param_1}/#comentarios`);
        location.pathname.includes('detalle-operaciones') && window.location.reload()
      } else {
        navigate(`/`);
      }
    } catch (error) {
      throw error;
    }
  };

  const getNotifications = async () => {
    try {
      const response = await getAllNavNotifications(token);
      if (response) {
        setAllNotifications(response.results);
        setNotificationDisplay(response.count);
        let arrayBool = response?.results.map((a) => a.leido);
        let boolCatcher = arrayBool?.includes(false);
        setAlert(boolCatcher);
      }
    } catch (error) {
      throw error;
    }
  };

  const closeSession = () => {
    Swal.fire({
      icon: "info",
      title: "¿Desea cerra su sesión?",
      text: "Su sesión se cerrará en caso de confirmar su acción.",
      showDenyButton: true,
      confirmButtonText: "Cerrar sesión",
      confirmButtonColor: "#FE7F76",
      denyButtonColor: "#1D19D2",
      denyButtonText: `Regresar`,
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        localStorage.removeItem("agencia");
        localStorage.removeItem("id");
        localStorage.removeItem("nombre_usuario");
        dispatch({ type: "CLOSE_AUTH" });
        navigate("/login");
      } else if (result.isDenied) {
        navigate(location);
      }
    });
  };

  return (
    <nav>
      <div className="container-fluid container_NavBar">
        <div className="row navBar">
          <div className="col-2">
            <Link to="/">
              <img src={logoAAAPver} alt="Logo de AAAPVER" />
            </Link>
          </div>
          <div
            className="col-3 navBar_bell d-flex justify-content-end"
            ref={menuRef}
          >
            {totalNotificaciones > 0 ? (
              <div className="navBar_bell_redDot">{totalNotificaciones}</div>
            ) : (
              <div className="navBar_bell_redDot d-none"></div>
            )}
            <button
              className="btn"
              style={{ padding: "0" }}
              onClick={() => {
                setIsOpen(!isOpen);
                getNotifications();
              }}
            >
              <FiBell size={"1.6rem"} />
            </button>
            <div className="dropdown">
              {isOpen && (
                <div className="dropdown-menu show">
                  <div className="row d-flex flex-row" style={{
                    overflow: 'scroll',
                    height:'300px',
                    width: '22rem'
                    }}>
                    <div className="col-12">
                      <table className="table">
                        <thead>
                          <tr>
                            <th scope="col" style={{ paddingLeft: "50px" }}>
                              Mensaje
                            </th>
                            <th scope="col"></th>
                          </tr>
                        </thead>
                        {alert ? (
                          allNotifications.map((value, index) => (
                            <tbody className="dropdown_menu_inside" key={index}>
                              <tr>
                              {!value.leido && (
                                <td>
                                    <button
                                      className="btn d-flex flex-row"
                                      onClick={() => notificationHandler(value)}
                                    >
                                      <div>
                                        <p
                                          style={{ fontFamily: "Inconsolata" }}
                                        ></p>
                                        <MessageUser
                                          messageType={value?.tipo}
                                          param1={value?.param_1}
                                          param2={value.param_2}
                                          param3={value.param_3}
                                          param4={value.param_4}
                                        />
                                      </div>
                                    </button>           
                                </td>
                                )}
                                {!value.leido && (
                                <td>
                                  <RxDotFilled
                                    size={"20px"}
                                    style={{ color: "#2F76FF" }}
                                  />                     
                                </td>
                                )}
                              </tr>
                            </tbody>
                          ))
                        ) : (
                          <tbody>
                            <tr>
                              <td style={{paddingLeft: '60px'}}>
                              <button className="btn d-flex flex-row">
                                  <div>
                                    <p>
                                      <RxExclamationTriangle
                                        size={"20px"}
                                        style={{
                                          color: "#2F76FF",
                                          margin: "0",
                                        }}
                                      />{" "}
                                      Sin mensajes aún
                                    </p>
                                    <p
                                      style={{ fontFamily: "Inconsolata" }}
                                    ></p>
                                  </div>
                                </button>               
                              </td>
                              <td></td>
                            </tr>
                          </tbody>
                        )}
                      </table>
                    </div>
                  </div>

                  <div className="d-grid gap-2">
                    <Link
                      to={"/mensajes-notificacion"}
                      className="btn btn-outline-primary"
                      style={{ borderRadius: 0, border: "none" }}
                      type="button"
                    >
                      Ver todos
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="col-3 navBar_user d-flex justify-content-center">
              <p className="navBar_role" style={{ fontFamily: "Inconsolata" }}>
              <p>Usuario:<b>{nombre_usuario}</b></p>
              </p>
          
          </div>
            <div className="col-2 navBar_name">
          {role === "AGA" && 
              <button
                onClick={() => navigate('/tutoriales')}
                className="btn"
                style={{ fontFamily: "Inconsolata" }}
              >
                Tutoriales
              </button>
          }
          </div>
          <div className="col-2 navBar_name">
        
            <button
              onClick={() => closeSession()}
              className="btn"
              style={{ fontFamily: "Inconsolata" }}
            >
              Cerrar sesión
            </button>
          </div>
        </div>
      </div>

      <div className="row navBar_below">
        <div className="col-1"></div>
        <div className="col-8">
          <Breadcrumb location={location} />
        </div>
        <div className="col-1"></div>
      </div>
    </nav>
  );
};

export default NavBar;
